import { OnScreenHelpMultiStep } from "../../../../../explorer/components/OnScreenHelp/OnScreenHelp";
import arrow from "../../../../../assets/images/icon-arrow-up.svg";

const AppHeaderHelp = () => {
  return (
    <OnScreenHelpMultiStep
        config={{
          id: "homePage",
          arrowIcon: arrow,
          showHideForGoodButton: true,
          items: [
            {
              className: "osh-hint-search",
              horizontal: "center",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.home.search",
              step: 1,
            },
            {
              className: "osh-hint-site-selector",
              horizontal: "center",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.home.gotocustomersite",
              step: 2,
            },
            {
              className: "osh-hint-site-machine-search",
              horizontal: "center",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.home.sitemachinesearch",
              step: 2,
            },
            {
              className: "osh-hint-mainbuttons",
              horizontal: "right",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.home.mainbuttons",
              isHTML: true,
              step: 3,
            },
            {
              className: "osh-hint-navigation-tree",
              horizontal: "right",
              vertical: "center",
              width: 1000,
              height: 1000,
              labelId: "common.onScreenHelp.hint.bom.navigationTree",
              step: 4,
            },
            {
              className: "osh-hint-navigation-lists",
              horizontal: "right",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.bom.navigationLists",
              step: 4,
            },
            {
              className: "osh-hint-basket-tools",
              horizontal: "right",
              vertical: "bottom",
              width: 300,
              height: 200,
              labelId: "common.onScreenHelp.hint.basket.tools",
              step: 5,
            }

            
          ],
        }}
      />
  );
}
export default AppHeaderHelp;